import { authService } from '../../../services/auth/AuthService';
import { getAuthToken } from '../../../utils/auth';

export const resolveAuthToken = (tokenHint = '') => {
  let token = '';
  try {
    token = authService?.getAccessToken?.() || '';
  } catch (_) {}

  if (!token) {
    token = getAuthToken() || tokenHint || '';
  }

  token = String(token || '').trim();
  const lower = token.toLowerCase();
  if (!token || lower === 'null' || lower === 'undefined' || token.split('.').length < 3) {
    return '';
  }

  return token;
};
